export const REQUEST_CD_TYPES = {
  IN_DEF_COMMON_FLAG_TYPE: "in_def_common_flag_type",
  TCKT_STS_TYPE_CPNT_PRJ_PRGRS: "tckt_sts_type_cpnt_prj_prgrs",
};

export const requestCdTypes = Object.values(REQUEST_CD_TYPES);
export const COMPONENT_PROJECT_LIST_TEMPLATE_FILE_URL =
  "spreadsheet-template/component-project-list.xlsx";

export const PJT_STS_LIST_PARAM_DELIMITER = "_";
